import dayjs from 'dayjs'
import jalaliday from 'jalaliday'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)
dayjs.extend(jalaliday)

export function distanceFromNow(date1) {
    if (!date1) return ''
    return dayjs(date1).locale('fa').fromNow()
}
